import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

export interface CitaTentativaModalData {
    id: number;
    fecha: string;
    am_pm: string;
    address: string;
    nombre_provincia: string;
    zona: string;
    nombre_entrega: string;
    contacto_entrega: string;
    telefono: string;
    created_by_canal: string;
    created_at: string;
}

@Component({
    selector: 'app-cita-tentativa-modal',
    templateUrl: './cita-tentativa-modal.component.html',
    styleUrls: ['./cita-tentativa-modal.component.scss']
})
export class CitaTentativaModalComponent {
    constructor(
        public dialogRef: MatDialogRef<CitaTentativaModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: CitaTentativaModalData
    ) {}

    cerrar(): void {
        this.dialogRef.close('cerrar');
    }

    atender(): void {
        this.dialogRef.close('atender');
    }
}
